import { UserSchema } from '@babyn-yar/schema';
import { toSearchParams } from '../params';
import { fetcher } from '../fetcher';
import { API_URL } from '../context';
import * as v from 'valibot';
export var UserAPI;
(function (UserAPI) {
    const BASE_URL = API_URL + '/users';
    async function list(filters) {
        const url = new URL(BASE_URL);
        url.search = toSearchParams(filters).toString();
        const response = await fetcher(url);
        return v.parse(UserSchema.ListResponse, response);
    }
    UserAPI.list = list;
    async function remove(id) {
        return fetcher(`${BASE_URL}/${id}`, { method: 'DELETE' });
    }
    UserAPI.remove = remove;
    async function me() {
        const response = await fetcher(BASE_URL + '/me');
        return v.parse(UserSchema.DetailResponse, response);
    }
    UserAPI.me = me;
    async function register(newUser) {
        const response = await fetcher(BASE_URL + '/register', {
            body: JSON.stringify(newUser),
            method: 'POST'
        });
        return v.parse(UserSchema.DetailResponse, response);
    }
    UserAPI.register = register;
    async function login(credentials) {
        const response = await fetcher(BASE_URL + '/login', {
            method: 'POST',
            body: JSON.stringify(credentials)
        });
        return v.parse(UserSchema.DetailResponse, response);
    }
    UserAPI.login = login;
    async function updateSettings(settings) {
        const body = { ...settings };
        for (const [key, value] of Object.entries(settings)) {
            if (!value) {
                delete body[key];
            }
        }
        const response = await fetcher(BASE_URL, {
            method: 'PATCH',
            body: JSON.stringify(body)
        });
        return v.parse(UserSchema.DetailResponse, response);
    }
    UserAPI.updateSettings = updateSettings;
    async function update(userId, input) {
        const response = await fetcher(`${BASE_URL}/${userId}`, {
            method: 'PATCH',
            body: JSON.stringify(input)
        });
        return v.parse(UserSchema.DetailResponse, response);
    }
    UserAPI.update = update;
    async function resetPassword(userId, input) {
        return fetcher(`${BASE_URL}/${userId}/password`, {
            method: 'PATCH',
            body: JSON.stringify(input)
        });
    }
    UserAPI.resetPassword = resetPassword;
})(UserAPI || (UserAPI = {}));
